import { useCallback } from "react";
import { MenuItem, Tooltip } from "@mui/material";
import UpDownArrows from "src/components/general/UpDownArrows/UpDownArrows";
import { getReadableDurationFromMinutes } from "src/utils/time/getReadableDuration";
import {
  ALL_TIME_LABEL,
  TIME_WINDOW_ALL_TIME,
} from "../../../../TimeWindow.constants";
import { durationMinutesToToken } from "../../../../TimeWindow.selection";
import { useTimeAdjustment } from "./TimeWindowPresetOption.hooks";
import type { TimeWindowPresetOptionProps } from "./TimeWindowPresetOption.types";

const TimeWindowPresetOption = ({
  t,
  label,
  tooltip,
  timeWindow,
  setTimeWindow,
  onSelect,
}: TimeWindowPresetOptionProps) => {
  const {
    localTime,
    handleAdjustTime,
    handleSelect: selectTimeWindow,
  } = useTimeAdjustment(t, setTimeWindow);

  const token = durationMinutesToToken(localTime);

  const handleSelect = useCallback(() => {
    selectTimeWindow();
    onSelect?.(token);
  }, [onSelect, selectTimeWindow, token]);

  return (
    <Tooltip arrow placement="left" title={tooltip}>
      <MenuItem
        data-test-id="time-window-option"
        value={durationMinutesToToken(t)}
        selected={timeWindow === token}
        onClick={handleSelect}
        className="gap-0.5 justify-between! pr-8! relative grid grid-cols-[auto_1fr] items-center"
      >
        {!label && (
          <UpDownArrows
            className="-ml-3"
            onUpClick={handleAdjustTime("up")}
            onDownClick={handleAdjustTime("down")}
            slotProps={{
              up: { "data-test-id": "time-window-up" },
              down: { "data-test-id": "time-window-down" },
            }}
          />
        )}
        {label ??
          (token === TIME_WINDOW_ALL_TIME
            ? ALL_TIME_LABEL
            : getReadableDurationFromMinutes(localTime, true))}
      </MenuItem>
    </Tooltip>
  );
};

export default TimeWindowPresetOption;
